import { render, staticRenderFns } from "./OrderConfirmationMailDialog.vue?vue&type=template&id=ff9ebd02&scoped=true&"
import script from "./OrderConfirmationMailDialog.vue?vue&type=script&lang=ts&"
export * from "./OrderConfirmationMailDialog.vue?vue&type=script&lang=ts&"
import style0 from "./OrderConfirmationMailDialog.vue?vue&type=style&index=0&id=ff9ebd02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_4b1a8e7b0323687afa589ac3884e675c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff9ebd02",
  null
  
)

export default component.exports